import React from 'react';
import PropTypes from 'prop-types';
import { BoldIcon, ItalicIcon, UnderlineIcon, StrikeIcon, ListOrderedIcon, ListBulletIcon } from '../../Icons';


import * as Ui from './styles';

/**
 * Componente que renderiza uma barra de ferramentas para se trabalhar
 * com RichText
 */
const propTypes = {
  tools: PropTypes.arrayOf(PropTypes.string),
};
const defaultProps = {
  tools: ['bold', 'italic', 'underline', 'strike', 'listOrdered', 'listBullet'],
};

const tollClassMapper = {

  textTransformation: {
    bold: { className: 'ql-bold', value: null, icon: <BoldIcon />, title: 'Negrito' },
    italic: { className: 'ql-italic', value: null, icon: <ItalicIcon />, title: 'Itálico' },
    underline: { className: 'ql-underline', value: null, icon: <UnderlineIcon />, title: 'Sublinhar' },
    strike: { className: 'ql-strike', value: null, icon: <StrikeIcon />, title: 'Tachar' },
  },

  listing: {
    listOrdered: { className: 'ql-list', value: 'ordered', icon: <ListOrderedIcon />, title: 'Lista numerada' },
    listBullet: { className: 'ql-list', value: 'bullet', icon: <ListBulletIcon />, title: 'Lista com marcadores' },
  },
};
function RichTextToolbarReferenciable(props, ref) {
  // state from props
  const { tools } = props;
  /**
     * O Quill nao reconhece os botoes de toolbar caso eles sejam definidos
     * após a reenderizacao, como em useEffect
     */
  const sectionButtons = buildNewTools();

  function buildNewTools() {
    const newTextTransformationTools = buildTextTransformationTools();
    const newListingTools = buildListTools();

    const newTools = [newTextTransformationTools, newListingTools];
    return newTools;
  }

  function buildSection(sectionKey) {
    const newTools = [];
    tools.forEach((tool) => {
      const toolData = tollClassMapper[sectionKey][tool];
      if (toolData) {
        newTools.push(<button className={`tool-item ${toolData.className}`} value={toolData.value} type="button" title={toolData.title}>{toolData.icon}</button>);
      }
    });
    return newTools;
  }

  function buildTextTransformationTools() {
    const newTools = buildSection('textTransformation');
    return newTools;
  }

  function buildListTools() {
    const newTools = buildSection('listing');
    return newTools;
  }

  return (
    <Ui.Container ref={ref} className="RichTextToolbarReferenciable_Container">
      {/* {
        sectionButtons.map((buttons, index) => (
          <div className="toolbar-item-section" key={`RichTextToolbar_section_${index}`}>
            {buttons.map((button, i) => (
              <div className="toolbar-toll-item-wrapper" key={`RichTextToolbar_tool_item_${index}_${i}`}>{button}</div>
            ))}
            {index < sectionButtons.length - 1 ? <span className="section-separator" /> : null}
          </div>
        ))
      } */}
    </Ui.Container>
  );
}
const RichTextToolbar = React.forwardRef(RichTextToolbarReferenciable);
RichTextToolbar.propTypes = propTypes;
RichTextToolbar.defaultProps = defaultProps;
export default RichTextToolbar;
